import React from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/solid";
import IconButtonLink from "./IconButtonLink";
import { cn } from "../utils/style";

function PageHeader({ back, title, description, children, className }) {
  return (
    <div
      className={cn(
        "relative pb-8 mb-10 border-b border-slate-200/60",
        className,
      )}
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div className="flex-auto">
          <div className="flex items-center gap-5">
            {back && (
              <IconButtonLink
                href={back}
                className="shadow-md hover:shadow-lg transition-all duration-300 active:scale-90"
              >
                <ArrowRightIcon
                  className="ltr:hidden h-5 w-5"
                  aria-hidden="true"
                />
                <ArrowLeftIcon
                  className="rtl:hidden h-5 w-5"
                  aria-hidden="true"
                />
              </IconButtonLink>
            )}
            <div className="space-y-1">
              <h1 className="text-3xl font-black tracking-tight text-slate-900 uppercase">
                {title}
                <span className="block h-1 w-12 bg-primary-500 rounded-full mt-2 shadow-[0_0_10px_rgba(59,130,246,0.5)]"></span>
              </h1>
            </div>
          </div>
          {description && (
            <p className="mt-4 text-sm font-medium text-slate-500 max-w-2xl leading-relaxed ms-1">
              {description}
            </p>
          )}
        </div>

        {children && (
          <div className="flex shrink-0 items-center gap-3 animate-in fade-in slide-in-from-right-4 duration-500">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}

export default PageHeader;
